import React from 'react';
import RoutesJs from "./routesJs";

const App = () => {
  return (
    <RoutesJs />
  );
}

export default App;